import React, { useState, useEffect } from 'react';
import { Typography, Row, Col, Pagination } from 'antd';
import { FileSearchOutlined, LinkOutlined } from '@ant-design/icons';
import { VertContainer, VertLoading } from '@vertem-core/vertice-ds';
import CustomCard from './CustomCard';
import { useDispatch, useSelector } from "react-redux";
import { getBallonsByParticipant } from 'redux/Reducers/PopBallon/VertemGiftApi';

const CustomExtract = () => {
    const dispatch = useDispatch();
    const { ballonsByParticipant } = useSelector(state => state.VertemGift);
    const [isLoading, setIsLoading] = useState(true);
    const [isEmpty, setIsEmpty] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

    useEffect(() => {
        dispatch(getBallonsByParticipant()).then(() => {
            setIsLoading(false);
        });
    }, [dispatch]);

    useEffect(() => {
        if (ballonsByParticipant.length > 0) {
            setIsEmpty(false);
        } else {
            setIsEmpty(true);
        }
    }, [ballonsByParticipant]);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = ballonsByParticipant.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <VertContainer>
            {isLoading && (
                <Row className='extract-page-loading' align='middle' justify='center' gutter={6}>
                    <VertLoading type="spin" size='small' />
                </Row>

            )}

            {isEmpty && !isLoading && (
                <Row className='extract-page-empty' align='middle' justify='center' gutter={6}>
                    <Col className='col'>

                        <Typography.Title level={3} style={{ textAlign: 'center' }}>
                            Você ainda não resgatou nenhum prêmio.
                        </Typography.Title>
                        <Typography.Paragraph style={{ textAlign: 'center' }}>
                            Faça um resgate para participar da nossa promoção!
                        </Typography.Paragraph>
                    </Col>
                </Row>
            )}

            {!isLoading && !isEmpty && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    {currentItems.map(item => (
                        <CustomCard
                            key={item.ballonParticipantId}
                            props={item}
                        />
                    ))}

                    <Pagination
                        current={currentPage}
                        pageSize={itemsPerPage}
                        total={ballonsByParticipant.length}
                        onChange={handlePageChange}
                        style={{ marginTop: '20px', textAlign: 'center' }}
                    />
                </div>
            )}
        </VertContainer>
    );
};

export default CustomExtract;
